import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, FileTextIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/vQ8mspS3agY2RiDWySpPGy/Mockup_1x1_-_OFN1_(C.P.E).webp';
export function Hero() {
  // Headline and mockup render immediately (no entrance animation) so the
  // largest contentful paint is never delayed by JavaScript.
  return <section className="relative overflow-hidden bg-surface px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-64" data-mp="12862k3i3uktp">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-primary/40" data-id="element-65" data-mp="xbpbp1jitscx" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-66" data-mp="sa9szg4tfxxp">
        <p className="-mb-2.5 -mt-11 font-display text-lg font-bold tracking-brand text-primary-soft sm:text-2xl" data-id="element-67" data-mp="ncglmjrs0xvu">
          🌿BIOMA LÍVIDO™
        </p>
        <h1 className="mx-auto mt-5 max-w-5xl font-display text-lg font-bold text-foreground sm:text-5xl lg:text-6xl" style={{
        fontSize: "22px"
      }} data-id="element-68" data-mp="3d33ecx6girk8">
          Organizá los cuidados diarios de tu familiar en cama{' '}
          <span className="text-primary-soft" data-id="element-69" data-mp="3j6odtpknkwsq">
            sin volver a preguntarte por dónde empezar.
          </span>
        </h1>
        <div className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-70" data-mp="39b4hx3639y3z">
          <img src={mockupUrl} alt="Mockup del Kit Cuidados en Cama" width="1254" height="1254" fetchPriority="high" loading="eager" decoding="async" className="aspect-square w-full drop-shadow-2xl" data-id="element-71" data-mp="3e9fsjg47kcn9" />
        </div>
        <div className="mx-auto max-w-2xl" data-id="element-72" data-mp="358ho4wpuy345">
          <p className="-mb-2 font-display text-base font-bold tracking-label text-highlight sm:text-xl" data-id="element-73" data-mp="35aaueawk6lbm">
            KIT CUIDADOS EN CAMA
          </p>
          <p className="-mb-2.5 mt-3 text-sm leading-relaxed text-foreground-soft sm:text-base" data-id="element-74" data-mp="2viokqizvcuaz">
            Un sistema práctico con 30 días de rutinas preparadas y guías visuales, incluso sin experiencia previa.
          </p>
          <div className="-mb-3 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-foreground-muted sm:text-sm" style={{
          marginBottom: "-18px"
        }} data-id="element-75" data-mp="2ljpch1j0n0oi">
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-76" data-mp="nat7bbcrskkp">
              <FileTextIcon className="h-4 w-4 text-primary-soft" data-id="element-77" data-mp="id02aln7dwm0" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-78" data-mp="deq6c8tnmrzc">
              <DownloadIcon className="h-4 w-4 text-highlight" data-id="element-79" data-mp="1ayt6mzo5djaw" />
              Materiales descargables
            </span>
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-80" data-mp="111ybmqr3211d">
          <ActionButton href="#pricing" showTrust data-id="element-81" data-mp="3lqm1dvdxqztc">
            🌿 QUIERO MI KIT CUIDADOS EN CAMA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}